import { TextField } from '@mui/material'
import { EnhancementGetResponse, SubmitStatus } from '../../../models/enhancement'
import { globalContent } from '../../../utils/constants'
import { findLatestCommentByStatus } from '../../../utils/SharedMethods/getCommentsFromStatusHistory'
import { RequestDatesCard } from '../../../shared/layout/RequestDatesCard'
import { getDateSubmittedFromStatusHistory } from '../../../utils/SharedMethods/getDateSubmittedFromStatusHistory'


export function TotalHoursCard({
  dateRange,
  statusHistory,
  totalHours,
  useShifts,
  createdBy,
  employeeDetails,
}: EnhancementGetResponse & { totalHours: string; useShifts?: boolean }) {
  const displayTotalHours = (() => {
    if (useShifts) return String(totalHours)
    return Number(totalHours) > 0 ? Number(totalHours).toFixed(2).toString() : '0.00'
  })()

  const isManualRequest =
    createdBy.id !== undefined &&
    employeeDetails?.id !== undefined &&
    createdBy.id !== employeeDetails.id

  const pendingComment = findLatestCommentByStatus(statusHistory, SubmitStatus.PENDING)
  const comment = pendingComment || (isManualRequest ? findLatestCommentByStatus(statusHistory, SubmitStatus.APPROVED) : '')

  const dateSubmitted = getDateSubmittedFromStatusHistory(statusHistory)
  const comments =
    <TextField
      label={globalContent.requesterComments}
      fullWidth
      multiline
      rows={4}
      disabled
      value={comment}
      data-testid="description"
    />

  return (
    <RequestDatesCard
      title={useShifts ? 'Shifts' : globalContent.totalHours}
      totalHours={displayTotalHours}
      dateFrom={dateRange.start}
      dateTo={dateRange.end}
      dateSubmitted={dateSubmitted}
      showFullTimestamp={false}
      extraItems={[comments]}
    />
  )
}
